<h1 mat-dialog-title>Are you sure you want to <b>Delete</b> this file from the project?</h1>
<div class="flex justify-end mt-4">
	<button (click)="closeModal()" class="mr-2" mat-button color="primary">Cancel</button>
	<button (click)="deleteFile()" mat-flat-button color="primary" class="mr-4 mb-4">Delete</button>
</div>
